import * as React from "react";

import classNames from "classnames";

interface GenListDisplayProps<Item> {
  selected: Array<Item>;
  setListSelected: (selected: Array<Item>) => void;
  listData?: Array<Item>;
  renderItem: (item: Item, isSelected?: boolean) => React.ReactElement;
}

export default function GenListDisplay<Item extends {id: number}>(
  {
    selected,
    setListSelected,
    listData,
    renderItem,
  }: GenListDisplayProps<Item>,
) {
  const onItemClick = (item: Item) => {
    const isSelected = selected.some((sItem) => sItem.id === item.id);
    const newSelectedItems = isSelected ? selected.filter((sItem) => sItem.id !== item.id) : selected.concat([item]);
    setListSelected(newSelectedItems);
  };

  const renderedItems = (listData || []).map((item) => {
    const isSelected = selected.some((sItem) => sItem.id === item.id);

    return (
      <div
        key={item.id}
        className={classNames("panel", "gen-list-display-panel", "py-3 mb-0", isSelected ? "selected bg-sky-100" : "")}
        onClick={() => {onItemClick(item);}}
      >
        {renderItem(item, isSelected)}
      </div>
    );
  });

  return (
    <div className="gen-list-display">
      {renderedItems}
    </div>
  );
}
